<template>
  <div
    class="d-flex justify-content-start align-content-center text-text-left flex-wrap gap-2"
  >
    <img
      v-if="isFirstName"
      alt="Visitor Profile Image"
      :src="profileImage"
      class="visitor-row-profile-image"
    />

    <!-- NAME -->
    <div class="my-auto visitor-row-name">
      {{ isFirstName ? visitor.profile.first_name : visitor.profile.last_name }}
    </div>
    <!-- NAME -->
  </div>
</template>

<script>
import { computed } from "vue"
export default {
  name: "VisitorNameColumn",
  props: {
    visitor: {
      type: Object,
      default: () => ({})
    },
    isFirstName: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const profileImage = computed(() => {
      return (
        props?.visitor?.profile?.profile_image_uri ||
        props?.visitor?.profile?.profile_image_thumbnail_uri ||
        "/img/avatars/user-avatar.jpeg"
      )
    })

    return {
      profileImage
    }
  }
}
</script>

<style scoped></style>
